<a (click)="goTo($event)" [ngClass]="class">
  <ng-content></ng-content>
</a>
